import { type SocialIconType } from '@on3/ui-lib/components/SocialIcon';

type SocialType = SocialIconType;

type ConnectSocial = {
  type: SocialType;
  handle: string;
  displayName?: string;
};

export interface ConnectData {
  brand?: 'on3' | 'rivals';
  avatarSrc: string;
  socials: ConnectSocial[];
  email?: string;
}

export const on3Data: ConnectData[] = [
  {
    brand: 'on3',
    avatarSrc: 'https://on3static.com/static/on3/on3-red.jpeg',
    socials: [
      {
        type: 'x',
        handle: 'on3sports',
      },
      {
        type: 'instagram',
        handle: 'on3',
      },
      {
        type: 'youtube',
        handle: '@On3sports',
        displayName: 'On3sports',
      },
    ],
  },
  {
    brand: 'rivals',
    avatarSrc: 'https://on3static.com/static/on3/rivals-mark.png',
    socials: [
      {
        type: 'x',
        handle: 'rivals',
      },
      {
        type: 'instagram',
        handle: 'rivals.ig',
      },
      {
        type: 'youtube',
        handle: '@RivalsRecruits',
        displayName: 'Rivals',
      },
    ],
  },
];

export const rivalsData: ConnectData[] = [
  {
    avatarSrc: 'https://on3static.com/static/on3/on3-red.jpeg',
    socials: [
      {
        type: 'x',
        handle: 'on3sports',
      },
      {
        type: 'instagram',
        handle: 'on3',
      },
      {
        type: 'youtube',
        handle: 'On3sports',
      },
    ],
  },
];

export const niluData: ConnectData[] = [
  {
    avatarSrc: 'https://on3static.com/static/on3/on3-nil-social.png',
    socials: [
      {
        type: 'x',
        handle: 'on3nil',
      },
      {
        type: 'x',
        handle: 'deals_nil',
      },
      {
        type: 'instagram',
        handle: 'on3nil',
      },
    ],
  },
];

export const transferPortalData: ConnectData[] = [
  {
    avatarSrc: 'https://on3static.com/static/on3/on3-transfer-portal.png',
    socials: [
      {
        type: 'x',
        handle: 'on3sports',
      },
      {
        type: 'instagram',
        handle: 'transferportal',
      },
    ],
  },
];

export const cfbData: ConnectData[] = [
  {
    brand: 'on3',
    avatarSrc: 'https://on3static.com/static/on3/on3-red.jpeg',
    socials: [],
  },
];
